import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import { FaEye, FaEdit, FaTrash, FaCommentDots, FaUserPlus } from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import { STATUS_OPTIONS } from '../../Constant/leadConstent';
import { getUserRole } from "../../Utils/role";
import LeadFilters from '../../common/leadFilter';
import Pagination from '../../common/Pagination';
import Swal from "sweetalert2";
import { getTodayAssignedLeadList, updateLeadStatus, deleteLead } from "../../redux/services/leadServices/Lead.Services"
function TodayAllLead() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const role = getUserRole();
    const isAdmin = role === "admin";
    const [leadData, setLeadData] = useState([]);

    const [filteredLeads, setFilteredLeads] = useState([]);
    const [activeFilter, setActiveFilter] = useState("all");
    const [page, setPage] = useState(1);
    const [showFilter, setShowFilter] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(false);
    const [limit, setLimit] = useState(100);
    const [totalLeads, setTotalLeads] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [counts, setCounts] = useState({
        all: 0,
    });
    const [filters, setFilters] = useState({
        status: "",
        source: "",
        customer_name: "",
        mobile: "",
        search: "",
        from_date: "",
        to_date: ""
    });
    const [selectedLeadIds, setSelectedLeadIds] = useState([]);
    const [assignLoading, setAssignLoading] = useState(false);
    const handleDelete = async (id) => {
        try {
            const res = await deleteLead({
                id: id,
            });
            successToast(res?.message);
            const updatedLeads = leadData.filter(item => item.id !== id);
            setLeadData(updatedLeads);
            setFilteredLeads(updatedLeads);
            setSelectedLeadIds(prev => prev.filter(leadId => leadId !== id));

        } catch (error) {
            errorToast(
                error?.response?.data?.message ||
                error?.message ||
                "Delete failed"
            );
        }
    };



    const handlePageChange = (newPage) => {
        if (
            newPage >= 1 &&
            newPage <= totalPages &&
            !tableLoading
        ) {
            setPage(newPage);
            fetchLeads(newPage, false);
        }
    };

    const handleStatusUpdate = async (data) => {
        try {
            await updateLeadStatus(data);
            Swal.fire({
                icon: "success",
                title: "Status Updated",
                text: "Lead status successfully updated!",
                timer: 1500,
                showConfirmButton: false
            });
            await fetchLeads(page);

        } catch (error) {
            console.log(error);
            errorToast("Status update failed");
        }
    };

    useEffect(() => {
        fetchLeads(1, true);
    }, []);
    const fetchLeads = async (pageNo = 1, isInitialLoad = false) => {
        try {
            if (isInitialLoad) {
                setInitialLoading(true);
            } else {
                setTableLoading(true);
            }
            const payload = {
                page: pageNo,
                per_page: limit,
            };

            const response = await getTodayAssignedLeadList(payload);

            const leads = (response?.data || [])

            console.log(response?.data);
            setPage(response?.current_page || 1);
            setTotalPages(response?.last_page || 1);
            setTotalLeads(response?.total || 0);
            setLeadData(leads);
            setFilteredLeads(leads);
            setCounts({ all: response?.total || leads.length });
            setSelectedLeadIds([]);

        } catch (error) {
            console.log(error);
            errorToast("Failed to fetch leads");
        } finally {
            setInitialLoading(false);
            setTableLoading(false);
        }
    };
    const tabs = [
        {
            label: `New Leads (${counts.all})`,
            className: "btn-all",
            value: "all",
        },
    ];
    const handleFilterClick = (filter) => {
        setActiveFilter(filter);

        if (filter === "all") {
            setFilteredLeads(leadData);
        }
    };

    const handleLimitChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setPage(1);
        fetchLeads(1, true);
    };
    const handleToggleFilter = () => {
        setShowFilter(!showFilter);
    };

    // 6. Loading UI में बदलाव:
    if (initialLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }

    return (
        <div>
               <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
                <div className="title_member">
                    <h4>Today Assigned Lead</h4>
                    <nav className="page-breadcrumb">
                        <Link to="/">Home</Link>
                        <span className="mx-2">/</span>
                        <span>Today Assigned Lead</span>
                    </nav>
                </div>
                <div className="d-flex flex-wrap gap-2 justify-content-end">
                      {tabs.map((tab, index) => (
                                <button
                                    key={index}
                                    className={`lead-btn btn-all ${tab.className}  ${activeFilter === tab.value ? "active" : ""
                                        }`}
                                    onClick={() => handleFilterClick(tab.value)}
                                >
                                    {tab.label}
                                </button>
                            ))}

                              <button
                            onClick={() => navigate("/add-lead")}
                            className="lead-btn btn-add"
                        >
                            Add Lead
                        </button>

                        <button
                            className="lead-btn btn-import"
                            onClick={() =>
                                dispatch(
                                    openModal({
                                        type: "import-lead",
                                        title: "Import Leads",
                                        data: null,
                                    })
                                )
                            }
                        >
                            Import Lead
                        </button>
                </div>
            </div>
       
           <div className='main_page'>
             {totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                    {/* <div className="d-flex align-items-center">
            <label className="mb-0 me-2">Show</label>
            <select
                className="form-select form-select-sm"
                style={{ width: "90px" }}
                value={limit}
                onChange={handleLimitChange}
            >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
            </select>
        </div> */}
                    <div className='d-flex justify-content-end mt-3'>
                        <Pagination
                            page={page}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>
                </div>
            )}
            <div className="st-wrapper-card">
                <div className="st-table-responsive">
                    <table className="table st-custom-table align-middle mb-0">
                        <thead>
                            <tr>

                                <th>Sr.No.</th>
                                <th>Lead Id</th>
                                <th> Name</th>
                                <th> Mobile No</th>
                                <th> Source</th>

                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableLoading ? (
                                <tr>
                                    <td colSpan="7" className="text-center py-5">
                                        <div className="spinner-border text-primary"></div>
                                    </td>
                                </tr>
                            ) : (

                                filteredLeads?.map((item, index) => (
                                    <tr key={item.id}>

                                        <td>{(page - 1) * limit + index + 1}</td>
                                        <td>{item.lead_id}</td>
                                        <td className="fw-semibold"> {item?.name} </td>
                                        <td>{item.mobile}</td>
                                        <td>{item.source}</td>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center justify-content-center gap-1">
                                                <button
                                                    className="st-action-btn st-view-btn"
                                                    onClick={() => navigate(`/view-lead/${item.id}`)}
                                                >
                                                    <FaEye />
                                                </button>
                                                {/* <button
                                                className="st-action-btn st-edit-btn"
                                                onClick={() => navigate(`/update-lead/${item.id}`)}
                                            >
                                                <FaEdit />
                                            </button> */}

                                                {role === "admin" && (
                                                    <>
                                                        <button
                                                            className="st-action-btn st-edit-btn"
                                                            onClick={() => navigate(`/update-lead/${item.id}`)}
                                                        >
                                                            <FaEdit />
                                                        </button>
                                                        <button
                                                            className="st-action-btn st-delete-btn"

                                                            onClick={() =>
                                                                dispatch(
                                                                    openModal({
                                                                        type: "delete-lead",
                                                                        title: "Delete Lead",
                                                                        data: {
                                                                            id: item.id,
                                                                            deleteFunction: deleteLead,
                                                                            refreshData: () => fetchLeads(page),
                                                                        },
                                                                    })
                                                                )
                                                            }
                                                        >
                                                            <FaTrash />
                                                        </button>
                                                    </>
                                                )}

                                                <button
                                                 className="st-action-btn st-view-btn"
                                                    onClick={() => navigate(`/remark-history/${item.id}`)}
                                                >
                                                    <FaCommentDots />
                                                </button>
                                            </div>

                                        </td>
                                    </tr>
                                )))}

                        </tbody>
                    </table>
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-end mt-3">
                            <Pagination
                                page={page}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
           </div>
        </div>
    );
}

export default TodayAllLead;